interface updateWinnerStyleProps {
  matchElement: HTMLElement;
  score1: string;
  score2: string;
  matchOverviewType?: 'basic' | 'detailPage';
}

/**
 * Funkce pro aktualizaci vzhledu týmu po skončení zápasu.
 * Zvyraznění vítěze zápasu.
 *
 * @param {HTMLElement} matchElement - HTMLElement - zápas, který má být aktualizován.
 *                                     Obashuje HMTLElementy s data atributy: 'data-match-score-1', 'data-match-score-2', 'data-match-team-name-1' a 'data-match-team-name-2'.
 * @param {string} score1 - Skóre prvního týmu.
 * @param {string} score2 - Skóre druhého týmu.
 * @param {string} matchOverviewType - typ výpisu zápasu ("basic" | "detailPage")
 */
export const updateWinnerStyle = ({
  matchElement,
  score1,
  score2,
  matchOverviewType = 'basic',
}: updateWinnerStyleProps): void => {
  if (!matchElement) return;

  const score1Element = matchElement.querySelector<HTMLElement>('[data-match-score-1]');
  const score2Element = matchElement.querySelector<HTMLElement>('[data-match-score-2]');
  const homeTeam = matchElement.querySelector<HTMLElement>('[data-match-team-name-1]');
  const awayTeam = matchElement.querySelector<HTMLElement>('[data-match-team-name-2]');

  if (!score1Element || !score2Element || !homeTeam || !awayTeam) return;

  // const winScore =
  //   Number(score1) > Number(score2)
  //     ? score1Element
  //     : Number(score1) < Number(score2)
  //       ? score2Element
  //       : null;
  //
  // if (!winScore) return;

  score1Element.classList.add('fin-score');
  score2Element.classList.add('fin-score');
  // winScore.classList.add('win-score');

  const winner =
    Number(score1) > Number(score2) ? homeTeam : Number(score1) < Number(score2) ? awayTeam : null;

  const typographyClass = matchOverviewType === 'basic' ? 'body2' : 'subtitle2';

  if (winner) {
    winner.classList.remove(`typography--${typographyClass}`);
    winner.classList.add(`typography--${typographyClass}-bold`);
  }
};
